import React from "react";
import { css } from "emotion";
import ColorServices from "../../services/ColorServices";

const pageWidth = css({
  maxWidth: 1200,
  margin: "0 auto"
});

const colors = {
  greyPurple: {
    backgroundColor: ColorServices.getColor("greyPurpleBackground")
  },
  purple: {
    backgroundColor: ColorServices.getColor("purpleMid")
  },
  greyDark: {
    backgroundColor: ColorServices.getColor("greyDarkBackground")
  },
  grey: {
    backgroundColor: ColorServices.getColor("greyBackground")
  },
  white: {
    backgroundColor: ColorServices.getColor("white")
  },
  turquoise: {
    backgroundColor: ColorServices.getColor("turquoise")
  }
};

const ContentBlock = ({ color = "white", sidePad = true, children, thing }) => {
  const standards = {
    ...colors[color],
    position: "relative",
    padding: `${React.Children.count(children) ? "72px" : "36px"} ${
      sidePad ? "80" : "0"
    }px`,
    "@media(max-width: 600px)": {
      padding: `${React.Children.count(children) ? "40px" : "20px"} ${
        sidePad ? "14" : "0"
      }px`
    }
  };

  return (
    <div className={css(standards)}>
      <div className={pageWidth}>{children}</div>
    </div>
  );
};

export default ContentBlock;
